// ----------------------------------------------------------------------------
// Nombre del Programa : apiRequest
// Autor               : Daniel Medina
// Compania            : Forward
// Proyecto/Procliente : P-24-1448-21                      Fecha: 18/AGO/2023
// Descripcion General : Clase que administra las peticiones a los distintos endpoint
// Programa Dependiente: N/A
// Programa Subsecuente: N/A
// Cond. de ejecucion  : N/A
// Dias de ejecucion   : N/A                                 Horario: N/A
//                              MODIFICACIONES
// ----------------------------------------------------------------------------
// Numero de Parametros:
// Parametros Entrada  :                                    Formato:
//
// Parametros Salida   : N/A                                Formato: N/A
// ----------------------------------------------------------------------------

import axios, { AxiosRequestHeaders } from 'axios';
import { getToken, getApiUrl, getApiKe } from './session';
import { RequestProps } from '../interfaces/apiInterfaces';

const apiRequestToken = ({
  endpoint,
  body,
  method = 'GET',
  token = true,
  multi_part,
}: RequestProps) => {
  var urlLocal = getApiUrl();
  /*if('https://apis-qa.prosa.lat/api/v1/front-institucional' == getApiUrl()){
    urlLocal = 'http://localhost:8080/api/v1/front-institucional'
  }*/
  const url = `${urlLocal}/${endpoint}`;
  let headers: any = {
    'Access-Control-Allow-Origin': window.location.origin,
    //'APIKEY': getApiKe(),
    //'Access-Control-Allow-Origin': '*',
    //'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept',
  };
  if (getApiKe() !== null && getApiKe() !== "") headers['user_key'] = getApiKe();
  if (token) headers['Authorization'] = 'Bearer ' + (getToken() || '');
  //if (token) headers['Authorization'] = '' + (getToken() || env.API_TOKEN_GENERICO);
  if (multi_part) headers['Content-Type'] = 'multipart/form-data';
  //console.log("headers", headers);
  
  return axios({
    url,
    method,
    data: body || null,
    headers,
  });
};

const apiRequestGetPublic = (url: string, headers?: AxiosRequestHeaders) => {
  return axios({ url, method: 'GET', headers });
};

export { apiRequestToken, apiRequestGetPublic };
